import * as ConfigTypes from './config/types';
import { initialize as initializeHistory } from './history';
import * as intercomTracker from './intercomTracker/intercomTracker';
import * as assertInterface from './interfaces/assertInterface';
import * as crashReporterInterface from './interfaces/crashReporterInterface';
import * as httpClientInterface from './interfaces/httpClientInterface';
import { localStorageInrerfaceInit, localStorageInterface } from './interfaces/localStorageInterface';
import * as trackerInterface from './interfaces/trackerInterface';
import * as localPreferences from './local-preferences';
import { initialize as initializePlatform } from './platform';
import * as PlatformTypes from './platform/types';
import coreSettings from './settings';

export const initializeUtilsCore = (options) => {
  const { history, platform, localStorage } = options;
  localStorageInrerfaceInit(localStorage);
  initializePlatform(platform);
  initializeHistory(history);
};
export const initialize = initializeUtilsCore;

export { default as config } from './config';
export * from './config';
export { ConfigTypes };

export { default as history } from './history';
export { localPreferences };
export { getLogger, configurator as loggerConfigurator } from './logger';

export { default as platform } from './platform';
export { PlatformTypes };

export { default as tracker } from './tracker';

export { httpClientInterface };
export { assertInterface };
export { crashReporterInterface };
export { localStorageInterface };
export { trackerInterface };
export { coreSettings };
export { intercomTracker };
